import { useCallback, useEffect, useState } from "react";
import webinarApi from "../../../services/webinarApi";

/**
 * Fetches the webinar config for a given slug. No cache — a stale plan is
 * worse than a brief loading flash on a checkout page. Mirrors useOfferConfig.
 */
export default function useWebinarConfig(slug) {
  const [webinar, setWebinar] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!slug) {
      setError({ message: "Missing webinar slug", status: 400 });
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const data = await webinarApi.getWebinarConfig(slug);
      setWebinar(data);
    } catch (err) {
      setError(err);
      setWebinar(null);
    } finally {
      setLoading(false);
    }
  }, [slug]);

  useEffect(() => {
    load();
  }, [load]);

  return { webinar, loading, error, reload: load };
}
